import React, {useEffect, useMemo, useState} from 'react';
import Layout from "../Layout";
import {tournamentApi, useGetTournamentRankingQuery} from "../apis/tournaments.api";
import {Tournament} from "../models/Tournament";
import {useNavigate} from "react-router-dom";
import {useAppDispatch} from "../app/hooks";
import {Notification} from "../models/Notification";
import {SecondaryNavigation} from "../components/ui/secondary-navigation.component";
import {BackButton} from '../components/ui/back-button';
import LeagueTitle from '../components/ranking/league-title.component';
import LiguePrizes from '../components/ranking/league-prizes.component';
import {ChampionshipRankingList} from "../components/tournament/championship-ranking.component";
import {useLocation} from "react-router";
import {GameCategory} from '../models/User';


const TournamentRankingPage: React.FC = () => {

  const tournamentId = useMemo<string>(() => new URLSearchParams(window.location.search).get('_sa_t_id') || '', []);
  // const tournamentType = useMemo<string>(() => new URLSearchParams(window.location.search).get('_sa_t_type') || '', []);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const loc = useLocation();

  const gameCategory = loc.state.gameCategory || GameCategory.INVEST_GAME;
  const pageIndex = 0;
  const pageSize = 1;

  // Use to get player for current user
  const {data: playersData, isLoading: arePlayersLoading} = useGetTournamentRankingQuery({
    gameCategory,
    pageIndex,
    pageSize
  });

  const [showLobby, setShowLobby] = useState(false);

  useEffect(() => {
    console.log("Load playersDatas");
    if(playersData){
      setShowLobby(playersData?.currentPlayer.tournamentNumber === -1);
    }
  }, [playersData]);

  useEffect(() => {
    const eventSource = new EventSource('/sse/tournament');
    eventSource.onmessage = ({data}) => {
      const json = JSON.parse(data);
      if (json.notification) {
        const notification: Notification = json.notification;
        if (notification.payload.id === tournamentId) {
          dispatch(tournamentApi.util.invalidateTags([{type: 'Tournament', id: tournamentId}]));
        }
      }
      // console.log('New message', JSON.parse(data));
    };

    eventSource.onerror = (e) => {
      // error log here
      console.log('error sse', e);
      eventSource.close();
    }
    return () => {
      eventSource.close();
    };
  }, []);

  return (
    <Layout>
      <div
        className="sticky top-10 md:top-12 w-screen flex flex-col bg-gradient-to-b from-orange-700 to-orange -mt-16 pt-14 md:pt-12 p-4 center pb-10">

        <div className='w-full flex justify-between center max-w-md'>

          <div className='justify-self-start invisible w-[0px]'>
            <BackButton label={""} callback={() => navigate(-1)}/>
          </div>

          {!arePlayersLoading && loc.state.gameCategory === GameCategory.INVEST_GAME && <>

            <SecondaryNavigation navItems={[
              {path: '/portfolio', name: 'Portfolio'},
              {
                path: '/invest-tournament-ranking',
                name: `${showLobby ? "Lobby": "Leaderboad"}`,
                state: {gameCategory: GameCategory.INVEST_GAME}},
            ]}/>

          </>
          }

          {!arePlayersLoading && loc.state.gameCategory === GameCategory.BET_GAME && <>

            <SecondaryNavigation navItems={[
              {path: '/tournament/previous', name: 'Closed'},
              {path: '/tournament/current', name: 'Open'},
              {
                path: '/bet-tournament-ranking',
                name: `${showLobby ? "Lobby": "Leaderboad"}`,
                state: {gameCategory: GameCategory.BET_GAME}},
            ]}/>

          </>
          }

          <span className={""}>
            {/* <CollectibleRewardComponent widthCss={""} displayInfoButton={true}/> */}
            <LiguePrizes/>
          </span>

        </div>

        {
          !arePlayersLoading && playersData && <>
            <LeagueTitle
              league={playersData.currentPlayer.league}
              status={playersData.currentPlayer.leagueStatus}
              leagueRank={Number(playersData.currentPlayer.leagueRank)}
            />
          </>
        }

        {/* <LeagueTitle league="iron" status={2} /> */}

      </div>

      <div className="w-full max-w-md px-4 justify-between items-center inline-flex">
      </div>

      <div className={"w-screen bg-white p-6 rounded-tl-2xl rounded-tr-2xl z-10 -mt-4 pb-24 center"}>

        {/*<TournamentRankingList tournamentId={tournamentId} tournamentType={tournamentType}/>*/}
        {
          !arePlayersLoading && playersData && <>
            <ChampionshipRankingList gameCategory={loc.state.gameCategory || GameCategory.INVEST_GAME} league={playersData.currentPlayer.league}/>
          </>
        }
      </div>




    </Layout>
  );
};

export {TournamentRankingPage}